import { sentbizApi } from '../axios'
import { IApiRequest } from '@/adapters/axios/IApiRequest'

export interface GetCorpBasicParams {
  use_remittance?: boolean;
  use_fraud?: boolean;
}

export interface CorpBasic {
  corp_id: number;
  corp_name: string;
}

export interface GetCorpBasicResponse {
  code: number;
  message: string;
  data?: {
    total_count: number;
    corp_basic: Array<CorpBasic>;
  };
}

export interface GetCorpBasic extends IApiRequest {
  getInstance (): GetCorpBasic;

  request (params: GetCorpBasicParams): Promise<GetCorpBasicResponse>;
}

export class GetCorpBasic implements GetCorpBasic {
  private static instance: GetCorpBasic

  private constructor () {
  }

  public static getInstance (): GetCorpBasic {
    if (!this.instance) this.instance = new GetCorpBasic()
    return this.instance
  }

  async request (params: GetCorpBasicParams): Promise<GetCorpBasicResponse> {
    const requestOption: RequestOption = {
      url: 'hades/corp_basic',
      method: 'get',
      params
    }
    const response: GetCorpBasicResponse = await sentbizApi.request(requestOption)
    return response
  }
}
